import { render } from "./UserTextResponse.vue?vue&type=template&id=680fbfcc&scoped=true"
import script from "./UserTextResponse.js?vue&type=script&lang=js&external"
export * from "./UserTextResponse.js?vue&type=script&lang=js&external"

import "./UserTextResponse.vue?vue&type=style&index=0&id=680fbfcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680fbfcc"],['__file',"src/Components/ChatWidget/UserTextResponse/UserTextResponse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "680fbfcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('680fbfcc', __exports__)) {
    api.reload('680fbfcc', __exports__)
  }
  
  module.hot.accept("./UserTextResponse.vue?vue&type=template&id=680fbfcc&scoped=true", () => {
    api.rerender('680fbfcc', render)
  })

}


export default __exports__